// extracted by mini-css-extract-plugin
export var baseButton = "_p3-0";
export var controlsArrowKeys = "_p3-1";
export var controlsResetButton = "_p3-2";
export var lightGameButton = "_p3-4 _p3-0";
export var playAgainButton = "_p3-5 _p3-0";
export var startGameButton = "_p3-3 _p3-0";